<adf-login
  [copyrightText]="'application.copyright' | adfAppConfig | translate"
  providers="ECM"
  (success)="onMyAuthLogin($event)"
  logoImageUrl="{{ myCustomLogo }}"
  backgroundImageUrl="{{ myCustomBg }}"
  [showRememberMe]="false"
  [showLoginActions]="false"
>
</adf-login>
